module.exports = __webpack_public_path__ + "static/DUMMYBANNER-b02af269acdb32a3cc3e0d7c722b4415.jpg";